// export type EscalationService = Extract<Service, Service.energy | Service.telecom | Service.water>;
export enum Service {
    energy = 'energy',
    telecom = 'telecom',
    water = 'water',
}
